import BreadcrumbSchema from '@/component/SeoTags/BreadcrumbSchema'
import HeadTag from '@/component/SeoTags/HeadTag'

import React, { useEffect, useState } from 'react'

import { useRouter } from "next/router";
import dayjs from 'dayjs'
import SVG from "react-inlinesvg";
import PageFlipBar from '@/component/GoldSilver/PageFlipBar'
import CurrentPriceCards from '@/component/GoldSilver/CurrentPriceCards'
import PriceCalculator from '@/component/GoldSilver/PriceCalculator'
import PriceChart from '@/component/GoldSilver/PriceChart'
import CityLinksPanel from '@/component/GoldSilver/CityLinksPanel'
import { PriceTable } from '@/component/GoldSilver/PriceTable'
import { CurrentRatesTable } from '@/component/GoldSilver/CurrentRatesTable'
import { PriceInfoTable } from '@/component/GoldSilver/PriceInfoTable'
import { CityCompareTable } from '@/component/GoldSilver/CityCompareTable'
import FaqAccordion from '@/component/GoldSilver/FaqAccordion'
import { buildGoldFaqs, buildSilverFaqs } from '@/component/GoldSilver/goldSilverFaqData'
import { buildGoldKeywords, buildSilverKeywords, buildGoldDescription, buildSilverDescription } from '@/component/GoldSilver/goldSilverSeoKeywords'
import { formatINR } from '@/utils/goldSilverParser'
import FaqSchema from '@/component/GoldSilver/FaqSchema'
import { TabsTable } from '@/component/GoldSilver/TabsTable'
import AdSlot300x250 from '@/component/Ads/AdSlot300x250'
import AdSlot728x90 from '@/component/Ads/AdSlot728x90'
import { createApsSlotsRosDesktop, createApsSlotsRosMobile, requestBiddingFromPWT, apstagBidCallback } from '@/utils/ads'
import NewsGrid from '@/component/GoldSilver/NewsList'
import { RWebShare } from 'react-web-share'
import Breadcrumb from '@/component/Breadcrumb/ElectionBreadCrumb';
import ItemsList from '@/component/SeoTags/ItemsList';
import WebpageSchema from '@/component/SeoTags/WebpageSchema';

const GoldSilverRatesPage = ({ categoryListData = [], city, city_hn, goldRatesData, silverRatesData, type, goldCityData, silverCityData }) => {
    // console.log("goldCityData", goldCityData?.map((c) => c.city));
    // console.log("categoryListData", categoryListData?.content);

    const router = useRouter();
    const currentURL = router.asPath?.split("?")[0];
    const isGold = type === "gold";
    const cityEn = city ? city.charAt(0).toUpperCase() + city.slice(1) : "";
    const cityLabel = city_hn || cityEn;
    const faqItems = isGold
        ? buildGoldFaqs(cityLabel, goldRatesData?.currentRates)
        : buildSilverFaqs(cityLabel, silverRatesData?.currentRates);
    const seoKeywords = isGold ? buildGoldKeywords(cityEn, cityLabel) : buildSilverKeywords(cityEn, cityLabel);
    const seoDescription = isGold
        ? buildGoldDescription(cityLabel, goldRatesData?.currentRates)
        : buildSilverDescription(cityLabel, silverRatesData?.currentRates);
    const colorClasses = {
        lightBgL: isGold ? "bg-[#F9F5E6]" : "bg-[#E5E7EB]/90",
        border: isGold ? "border-[#F0E6C0]" : "border-[#E5E7EB]",
        lightBg: isGold ? "bg-[#F0E6C0]/40" : "bg-[#E5E7EB]/50",
        gradient: isGold ? "bg-[linear-gradient(90deg,#F0A500_0%,#FFDF10_50%,#F4B000_100%)]" : "bg-[linear-gradient(90deg,#C8C8C8_0%,#F4F4F4_48%,#BDBDBD_100%)]",
    }
    const sevenDaysHistory = isGold ? goldRatesData?.sevenDaysHistory : silverRatesData?.sevenDaysHistory;
    const todayEntry = sevenDaysHistory?.rates?.[0];
    const yesterdayEntry = sevenDaysHistory?.rates?.[1];
    const todayPrice10g = isGold
        ? (todayEntry?.carat24 != null ? todayEntry.carat24 * 10 : null)
        : (todayEntry?.tenGram ?? null);
    const yesterdayPrice10g = isGold
        ? (yesterdayEntry?.carat24 != null ? yesterdayEntry.carat24 * 10 : null)
        : (yesterdayEntry?.tenGram ?? null);
    const priceDiff10g = todayPrice10g != null && yesterdayPrice10g != null ? todayPrice10g - yesterdayPrice10g : null;
    const priceTrend = priceDiff10g > 0 ? "increase" : priceDiff10g < 0 ? "decrease" : "same";
    const yesterdayDateLabel = yesterdayEntry?.date ? dayjs(yesterdayEntry.date).format("MMM DD, YYYY") : dayjs().subtract(1, "day").format("MMM DD, YYYY");
    const gold22k1g = formatINR(goldRatesData?.currentRates?.oneGram?.carat22);
    const gold24k1g = formatINR(goldRatesData?.currentRates?.oneGram?.carat24);
    const gold20k1g = formatINR(Math.round((goldRatesData?.currentRates?.oneGram?.carat24 || 0) * 20 / 24));
    const gold18k1g = formatINR(goldRatesData?.currentRates?.oneGram?.carat18);
    const silver1kg = formatINR(silverRatesData?.currentRates?.oneKg);
    const silver100g = formatINR(silverRatesData?.currentRates?.hundredGram);
    const content = isGold
        ? ` ${city_hn} में आज Gold Price चेक करें. 24 कैरेट सोना ${gold24k1g} प्रति ग्राम रुपए में, 22 कैरेट सोना ${gold22k1g} प्रति ग्राम रुपए में और 18 कैरेट सोना ${gold18k1g} प्रति ग्राम रुपए में है. साथ ही पिछले 10 दिनों का गोल्ड रेट ट्रेंड, हिस्टोरिकल डेटा, सोने के भाव का कैलकुलेटर, सोने में निवेश को लेकर सलाह और सोने से जुड़े आपके सवालों के जवाब भी.`
        : `जानें ${city_hn || city} में आज कितना है चांदी का भाव. 1 ग्राम  से 1 किलो ग्राम के चांदी के दाम के साथ ही देखें बीते 10 दिनों के चांदी प्राइस ट्रेंड, ऐतिहासिक आंकड़े, सिल्वर कैलकुलेटर, इन्वेस्टमेंट गाइड और FAQs भी.`

    // ads implements
    const [isScroll, setIsScroll] = useState(false);
    const keyBindings = {
        Category: [isGold ? "Gold-Rates" : "Silver-Rates"],
        Keywords: seoKeywords ? seoKeywords.split(",") : [],
    };

    useEffect(() => {
        function handleScroll() {
            if (!isScroll) {
                setIsScroll(true);
            }
        }
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isScroll]);

    useEffect(() => {
        const run = () => {
            window.googletag = window.googletag || { cmd: [] };

            if (window.screen.width < 900) {
                googletag.cmd.push(function () {
                    if (!isScroll) {
                        googletag.destroySlots();
                        googletag
                            .defineSlot(
                                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                                [300, 250],
                                "div-gpt-ad-1659434453897-0"
                            )
                            ?.addService(googletag.pubads());

                        googletag
                            .defineSlot(
                                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                                [320, 50],
                                "div-gpt-ad-1659435612077-0"
                            )
                            .addService(googletag.pubads());


                    }
                    if (isScroll) {
                        // mtf-1
                        googletag
                            .defineSlot(
                                "/1007232/News_tak_Mobile_ROS_MTF-1_300x250",
                                [300, 250],
                                "div-gpt-ad-1659434604998-0"
                            )
                            ?.addService(googletag.pubads());
                        // mtf-2
                        googletag
                            .defineSlot(
                                "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                                [300, 250],
                                "div-gpt-ad-1659434785315-0"
                            )
                            ?.addService(googletag.pubads());
                        // btf
                        googletag
                            .defineSlot(
                                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                                [300, 250],
                                "div-gpt-ad-1659435474737-0"
                            )
                            ?.addService(googletag.pubads());
                    }

                    googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
                    googletag.enableServices();
                    requestBiddingFromPWT();
                    !isScroll && googletag.cmd.push(function () {
                        var INTERSTITIALAd = googletag
                            .defineOutOfPageSlot(
                                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                                googletag.enums.OutOfPageFormat.INTERSTITIAL
                            )
                            .addService(googletag.pubads());

                        googletag.display(INTERSTITIALAd);
                    });
                });
            } else {
                googletag.cmd.push(function () {
                    if (!isScroll) {
                        googletag.destroySlots();
                        googletag
                            .defineSlot(
                                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                                [728, 90],
                                "div-gpt-ad-1659424515060-0"
                            )
                            ?.addService(googletag.pubads());
                        googletag
                            .defineSlot(
                                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                                [300, 250],
                                "div-gpt-ad-1707804176041-1"
                            )
                            ?.addService(googletag.pubads());

                    }

                    if (isScroll) {
                        // mtf-1
                        googletag
                            .defineSlot(
                                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                                [728, 90],
                                "div-gpt-ad-1707804176041-2"
                            )
                            ?.addService(googletag.pubads());
                        // mtf-2
                        googletag
                            .defineSlot(
                                "/1007232/News_tak_Desktop_ROS_MTF_2_728x90",
                                [728, 90],
                                "div-gpt-ad-1707804176041-3"
                            )
                            ?.addService(googletag.pubads());
                        // btf
                        googletag
                            .defineSlot(
                                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                                [728, 90],
                                "div-gpt-ad-1659425743360-0"
                            )
                            ?.addService(googletag.pubads());
                    }

                    googletag.setConfig({ disableInitialLoad: true, targeting: keyBindings });
                    googletag.enableServices();
                    requestBiddingFromPWT();
                });
            }

            if (isScroll) {
                window.apstag?.fetchBids(
                    {
                        slots:
                            window.screen.width < 900
                                ? createApsSlotsRosMobile({ mtf2: true, mtf3: false, btf: true })
                                : createApsSlotsRosDesktop({ mtf2: true, mtf3: true, btf: false }),
                        timeout: 2e3,
                    },
                    apstagBidCallback
                );
            }
        };

        const timer = setTimeout(run, isScroll ? 10 : 200);
        return () => clearTimeout(timer);
    }, [isScroll]);

    const metas = {
        title: isGold ? `${city_hn} में आज सोने का भाव: 24K, 22K और 18K Gold Rate Today, 10 ग्राम की कीमत (${dayjs().format("DD MMMM YYYY")}) - News Tak` :
            `${city_hn} में आज चांदी भाव क्या है: 1 किलो, 100 ग्राम और 10 ग्राम Silver Rate Today (${dayjs().format("DD MMMM YYYY")}) - News Tak`,
        description: isGold ? `${city_hn} में Gold Price Today (${dayjs().format("DD/MMMM/YYYY")}): आज सोने की कीमत कितनी है? जानें 24 कैरेट, 22 कैरेट और 18 कैरेट गोल्ड का ताजा भाव, 10 ग्राम सोने आज कितना सस्ता या कितना महंगा हुआ है. जानिए सर्राफा बाजार का लेटेस्ट अपडेट` :
            `${city_hn} में Silver Price Today (${dayjs().format("DD/MMMM/YYYY")}): आज चांदी कितने रुपये किलो मिल रही है? यहां जानें 1 किलो, 100 ग्राम और 10 ग्राम चांदी की ताजा कीमत, भाव में तेजी या गिरावट को लेकर सर्राफा बाजार की पूरी जानकारी`,
        keywords: isGold ? `${cityEn} Gold Price Today, ${cityEn} Gold Rate Today, ${city_hn} में आज सोने का भाव, आज का सोने का भाव, 22 कैरेट गोल्ड रेट, 24 कैरेट सोने का भाव, 18 कैरेट सोने का भाव, Gold Price Today, Gold Rate Today, 10 Gram Gold Price, ${city_hn} सर्राफा बाजार, Gold Price in ${cityEn}` :
            ` ${cityEn} Silver Price Today, ${cityEn} Silver Rate Today, ${city_hn} में आज चांदी का भाव, आज का चांदी का भाव, 1 किलो चांदी का रेट, 100 ग्राम चांदी का भाव, 10 ग्राम चांदी की कीमत, Silver Price Today, Silver Rate Today, 1 Kg Silver Price, ${city_hn} सर्राफा बाजार, Silver Price in ${cityEn}`,
    }
    const breadcrumbList = [
        ...(categoryListData?.category_detail || []),

        {
            title: city_hn,
            canonical_url: process.env.NEXT_PUBLIC_WEBSITE_URL + currentURL
        }
    ]
    return (
        <section>
            <HeadTag
                title={
                    metas.title
                }
                description={metas.description}
                keywords={metas.keywords}
                canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentURL}
                ogTitle={
                    metas.title
                }
                ogDescription={
                    metas.description}
                image={""}
                lcpImage={
                    ""
                }
            />
            <FaqSchema faqData={faqItems} />
            <WebpageSchema title={metas.title} description={metas.description}
                keywords={metas.keywords} canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + currentURL} />
            <BreadcrumbSchema
                breadcrumbList={breadcrumbList}
            />
            <ItemsList data={categoryListData?.content} />
            <Breadcrumb
                breadcrumbList={
                    breadcrumbList
                }
            />
            {/* atf */}
            <div className="mx-4 md:mx-6 my-2">
                <AdSlot300x250
                    divId="div-gpt-ad-1659434453897-0"
                    minWidth="300px"
                    minHeight="250px"
                />


                <AdSlot728x90
                    divId="div-gpt-ad-1659424515060-0"
                    minWidth="728px"
                    minHeight="90px"
                />
            </div>
            {/* Header Section/Content */}
            <div className="mx-4 my md:mx-6 my-2">
                {/* first decription */}
                <div className="flex flex-col  md:flex-row items-center justify-between w-full">

                    {/* show on mobile */}

                    <div className="  flex md:hidden my-3  gap-x-6 w-full justify-between">
                        {/* Date */}
                        <div className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-xl bg-white shadow-sm">
                            <SVG
                                src="https://akm-img-a-in.tosshub.com/lingo/uptak/resources/prod/calender.svg"
                                loading="eager"
                                className="w-5 h-5"
                            />

                            <p className="text-sm font-medium text-gray-700">
                                {dayjs().format("DD MMMM YYYY")}
                            </p>
                        </div>

                        {/* Share */}
                        <div className="inline-flex items-center gap-2 cursor-pointer">


                            <RWebShare
                                data={{
                                    text: isGold ? "Gold Rates" : "Silver Rates",
                                    url: process.env.NEXT_PUBLIC_WEBSITE_URL + currentURL,
                                    title: isGold ? "Gold Rates" : "Silver Rates",
                                }}
                                sites={[
                                    "copy",
                                    "facebook",
                                    "twitter",
                                    "whatsapp",
                                    "mail",
                                    "linkedin",
                                    "reddit",
                                ]}
                                text="Share"
                            ><div className="inline-flex items-center gap-1 ">
                                    <span className="text-sm font-medium">Share</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 48 48">
                                        <path d="M 36 5 C 32.151772 5 29 8.1517752 29 12 C 29 12.585766 29.198543 13.109464 29.335938 13.654297 L 17.345703 19.652344 C 16.059118 18.073938 14.181503 17 12 17 C 8.1517722 17 5 20.151775 5 24 C 5 27.848225 8.1517722 31 12 31 C 14.181503 31 16.059118 29.926062 17.345703 28.347656 L 29.335938 34.345703 C 29.198543 34.890536 29 35.414234 29 36 C 29 39.848225 32.151772 43 36 43 C 39.848228 43 43 39.848225 43 36 C 43 32.151775 39.848228 29 36 29 C 33.818497 29 31.940882 30.073938 30.654297 31.652344 L 18.664062 25.654297 C 18.801457 25.109464 19 24.585766 19 24 C 19 23.414234 18.801457 22.890536 18.664062 22.345703 L 30.654297 16.347656 C 31.940882 17.926062 33.818497 19 36 19 C 39.848228 19 43 15.848225 43 12 C 43 8.1517752 39.848228 5 36 5 z M 36 8 C 38.226909 8 40 9.7730927 40 12 C 40 14.226907 38.226909 16 36 16 C 33.773091 16 32 14.226907 32 12 C 32 9.7730927 33.773091 8 36 8 z M 12 20 C 14.226909 20 16 21.773093 16 24 C 16 26.226907 14.226909 28 12 28 C 9.7730915 28 8 26.226907 8 24 C 8 21.773093 9.7730915 20 12 20 z M 36 32 C 38.226909 32 40 33.773093 40 36 C 40 38.226907 38.226909 40 36 40 C 33.773091 40 32 38.226907 32 36 C 32 33.773093 33.773091 32 36 32 z"></path>
                                    </svg>
                                </div>
                            </RWebShare>
                        </div>
                    </div>
                    <h1 className="font-bold text-xl">
                        {isGold ? `${city_hn || city} में आज सोने का भाव (${cityEn} Gold Price Today)`
                            : `${city_hn || city} में आज के चांदी का भाव (${cityEn} Silver Price Today)`}
                    </h1>
                    {/* hide from mobile */}
                    <div className=" hidden md:flex  items-center gap-x-6 w-full justify-between  md md:w-[35%]">
                        {/* Date */}
                        <div className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-xl bg-white shadow-sm">
                            <SVG
                                src="https://akm-img-a-in.tosshub.com/lingo/uptak/resources/prod/calender.svg"
                                loading="eager"
                                className="w-5 h-5"
                            />

                            <p className="text-sm font-medium text-gray-700">
                                {dayjs().format("DD MMM YYYY")}
                            </p>
                        </div>

                        {/* Share */}
                        <div className="inline-flex items-center  gap-2 cursor-pointer">

                            <RWebShare
                                data={{
                                    text: isGold ? "Gold Rates" : "Silver Rates",
                                    url: process.env.NEXT_PUBLIC_WEBSITE_URL + currentURL,
                                    title: isGold ? "Gold Rates" : "Silver Rates",
                                }}
                                sites={[
                                    "copy",
                                    "facebook",
                                    "twitter",
                                    "whatsapp",
                                    "mail",
                                    "linkedin",
                                    "reddit",
                                ]}
                                text="Share"
                            ><div className="inline-flex items-center gap-1 ">
                                    <span className="text-sm font-medium">Share</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 48 48">
                                        <path d="M 36 5 C 32.151772 5 29 8.1517752 29 12 C 29 12.585766 29.198543 13.109464 29.335938 13.654297 L 17.345703 19.652344 C 16.059118 18.073938 14.181503 17 12 17 C 8.1517722 17 5 20.151775 5 24 C 5 27.848225 8.1517722 31 12 31 C 14.181503 31 16.059118 29.926062 17.345703 28.347656 L 29.335938 34.345703 C 29.198543 34.890536 29 35.414234 29 36 C 29 39.848225 32.151772 43 36 43 C 39.848228 43 43 39.848225 43 36 C 43 32.151775 39.848228 29 36 29 C 33.818497 29 31.940882 30.073938 30.654297 31.652344 L 18.664062 25.654297 C 18.801457 25.109464 19 24.585766 19 24 C 19 23.414234 18.801457 22.890536 18.664062 22.345703 L 30.654297 16.347656 C 31.940882 17.926062 33.818497 19 36 19 C 39.848228 19 43 15.848225 43 12 C 43 8.1517752 39.848228 5 36 5 z M 36 8 C 38.226909 8 40 9.7730927 40 12 C 40 14.226907 38.226909 16 36 16 C 33.773091 16 32 14.226907 32 12 C 32 9.7730927 33.773091 8 36 8 z M 12 20 C 14.226909 20 16 21.773093 16 24 C 16 26.226907 14.226909 28 12 28 C 9.7730915 28 8 26.226907 8 24 C 8 21.773093 9.7730915 20 12 20 z M 36 32 C 38.226909 32 40 33.773093 40 36 C 40 38.226907 38.226909 40 36 40 C 33.773091 40 32 38.226907 32 36 C 32 33.773093 33.773091 32 36 32 z"></path>
                                    </svg>
                                </div>
                            </RWebShare>

                        </div>


                    </div>


                </div>
                <p className={`text-sm my-4 text-[#777]`}>
                    {content}</p>
            </div>

            {/* First Panel - Calculator/Current Prices */}
            <div className="mx-4 md:mx-6 my-2 p-3 border border-zinc-300 rounded-lg">
                <PageFlipBar data={isGold ? goldCityData : silverCityData} city={city} colors={colorClasses} isGold={isGold} />
                <CurrentPriceCards colors={colorClasses} isGold={isGold} currentPriceData={isGold ? goldRatesData?.currentRates : silverRatesData?.currentRates} />
                <PriceCalculator colors={colorClasses} isGold={isGold} currentPriceData={isGold ? goldRatesData?.currentRates : silverRatesData?.currentRates} />
            </div>

            {/* current rates table */}
            <div className={`mx-4 mt-4 md:mx-6 my-2  overflow-hidden rounded-lg border   border-zinc-300 shadow-sm`}>
                <div className="inline-flex flex-wrap p-3 gap-x-1 text-[16px] font-semibold">
                    <h2>{isGold ? `${city_hn || city} में आज का गोल्ड रेट` : `आज ${city_hn || city} में आज का सिल्वर रेट`}
                        {" "}  <span className="text-[#6A7282]">{isGold ? `(${city.charAt(0).toUpperCase() + city.slice(1)} Gold Rate Today)` : `(${city.charAt(0).toUpperCase() + city.slice(1)} Silver Rate Today)`}</span></h2>
                </div>
                <CurrentRatesTable
                    data={isGold ? goldRatesData?.currentRates : silverRatesData?.currentRates}
                    type={isGold ? "gold" : "silver"}
                    colors={colorClasses}
                />
            </div>
            {/* price info summary table */}
            <div className={`mx-4 mt-4 md:mx-6 my-2  overflow-hidden rounded-lg border   border-zinc-300 shadow-sm`}>
                <div className="p-3">
                    <h2 className="text-[16px] font-semibold">
                        {isGold
                            ? `${city_hn} में आज 24 कैरेट, 22 कैरेट, 18 कैरेट और 14 कैरेट सोने का भाव`
                            : `${city_hn} में आज 1 ग्राम, 10 ग्राम, 100 ग्राम और 1000 ग्राम चांदी का भाव`}
                    </h2>
                    <p className="text-sm text-[#777] mt-1">
                        {isGold
                            ? `${city_hn} में आज सोने की रेट में बेहद मामूली बदलाव देखने को मिला है. 24 कैरेट सोना ${gold24k1g} प्रति ग्राम और 22 कैरेट सोना ${gold22k1g} प्रति ग्राम पर है. तीज-त्यौहार, गिफ्ट और शादी-ब्याह के खरीदारों के अलावा सोने में निवेश करने वालों के लिए ये जानकारी मददगार साबित होगी.`
                            : `${city_hn} में आज चांदी के भाव बदल गए है. आज 1 किलो चांदी ${silver1kg} और 100 ग्राम चांदी ${silver100g} में बिक रही है. आप गहने खरीदने या चांदी में पैसे लगाने की सोच रहे हैं, तो रोज चांदी के ताजा भाव जानना आपके लिए काफी जरूरी है.`}
                    </p>
                </div>
                <PriceInfoTable
                    city={city_hn}
                    currentRates={isGold ? goldRatesData?.currentRates : silverRatesData?.currentRates}
                    historyData={isGold ? goldRatesData?.tenDayHistory : silverRatesData?.tenDayHistory}
                    type={isGold ? "gold" : "silver"}
                    colors={colorClasses}
                />
            </div>
            {/* mtf-1 */}
            {isScroll && (
                <div className="mx-4 md:mx-6 my-2">
                    <AdSlot300x250
                        divId="div-gpt-ad-1659434604998-0"
                        minWidth="300px"
                        minHeight="250px"
                    />


                    <AdSlot728x90
                        divId="div-gpt-ad-1707804176041-2"
                        minWidth="728px"
                        minHeight="90px"
                    />
                </div>
            )}
            {/* last 10 days based Price table */}
            <div className={`mx-4 mt-4 md:mx-6 my-2  overflow-hidden rounded-lg border   border-zinc-300 shadow-sm`}>
                <div className="inline-flex flex-wrap p-3 gap-x-1 text-[16px] font-semibold">
                    <h2>{isGold ? `पिछले 10 दिनों में ${city_hn || city} में सोने का कैसा रहा है भाव ` : ` बीते 10 दिनों में ${city_hn || city} में कितना रहा चांदी का दाम`}
                        {" "}  <span className="text-[#6A7282]">{isGold ? `(Last 10 Days Gold Rates in ${city.charAt(0).toUpperCase() + city.slice(1)})` : `(Last 10 Days Silver Rates in ${city.charAt(0).toUpperCase() + city.slice(1)})`}</span></h2>
                </div>
                <PriceTable

                    data={isGold ? goldRatesData?.tenDayHistory : silverRatesData?.tenDayHistory}

                    type={isGold ? "gold" : "silver"}
                    colors={colorClasses}
                />
            </div>

            {/* 7 days chart */}
            <div className="mx-4 mt-4 md:mx-6 my-2 p-3 border border-zinc-300 rounded-lg">
                <div className="inline-flex flex-wrap gap-x-1 text-[16px] font-semibold mb-2">
                    <h2>{isGold ? "पिछले 7 दिनों में सोने के भाव का ट्रेंड" : "पिछले 7 दिनों में चांदी के भाव का ट्रेंड"}
                        {""}  <span className="text-[#6A7282]">{isGold ? `(Weekly Gold Rate Trend in ${city.charAt(0).toUpperCase() + city.slice(1)})` : `(Weekly Silver Rate Trend in ${city.charAt(0).toUpperCase() + city.slice(1)})`}</span></h2>
                </div>

                <PriceChart isGold={isGold} priceData={isGold ? goldRatesData?.sevenDaysHistory : silverRatesData?.sevenDaysHistory} is30={false} />
            </div>

            {/* 30 days chart */}
            <div className="mx-4 mt-4 md:mx-6 my-2 p-3 border border-zinc-300 rounded-lg">
                <div className="inline-flex flex-wrap gap-x-1 text-[16px] font-semibold mb-2">
                    <h2>{isGold ? "पिछले 30 दिनों में सोने का कैसा रहा है भाव" : "पिछले 30 दिनों में चांदी का कैसा रहा है भाव"}
                        {" "}  <span className="text-[#6A7282]">{isGold ? `(Monthly Gold Price Trend in ${city.charAt(0).toUpperCase() + city.slice(1)})` : `(Monthly Silver Price Trend in ${city.charAt(0).toUpperCase() + city.slice(1)})`}</span></h2>
                </div>

                <PriceChart isGold={isGold} priceData={isGold ? goldRatesData?.thirtyDaysHistory : silverRatesData?.thirtyDaysHistory} is30={true} />
            </div>
            {/*  */}
            <div className={`mx-4 mt-4 md:mx-6 my-2  overflow-hidden rounded-lg border   border-zinc-300 shadow-sm`}>
                <div className="inline-flex flex-wrap p-3 gap-x-1 text-[16px] font-semibold">
                    <h2>{isGold ? ` ${city_hn || city} में सोने की कीमतों का रिकॉर्ड ` : ` ${city_hn || city} में चांदी की कीमतों का रिकॉर्ड`}
                        {' '} <span className="text-[#6A7282]">{isGold ? `(Historical Gold Rate Data in ${city.charAt(0).toUpperCase() + city.slice(1)})` : `(Historical Silver Rate Data in ${city.charAt(0).toUpperCase() + city.slice(1)})`}</span></h2>
                </div>
                <TabsTable

                    data={isGold ? goldRatesData : silverRatesData}

                    type={isGold ? "gold" : "silver"}
                    colors={colorClasses}
                />
            </div>

            {/* nearby cities comparison table */}
            <div className={`mx-4 mt-4 md:mx-6 my-2  overflow-hidden rounded-lg border   border-zinc-300 shadow-sm`}>
                <div className="inline-flex flex-wrap p-3 gap-x-1 text-[16px] font-semibold">
                    <h2>{isGold ? `${city_hn || city} और आसपास के शहरों में गोल्ड रेट की तुलना` : `${city_hn || city} और दूसरे बड़े शहरों में चांदी की कीमतों की तुलना`}
                        {" "} <span className="text-[#6A7282]">{isGold ? "(Compare Gold Prices in Nearby Cities)" : "(Compare Silver Prices in Nearby Cities)"}</span></h2>
                </div>
                <CityCompareTable
                    data={isGold ? goldCityData : silverCityData}
                    city={city}
                    type={isGold ? "gold" : "silver"}
                    colors={colorClasses}
                />
            </div>
            {/* mtf-2 */}
            {isScroll && (
                <div className="mx-4 md:mx-6 my-2">
                    <AdSlot300x250
                        divId="div-gpt-ad-1659434785315-0"
                        minWidth="300px"
                        minHeight="250px"
                    />


                    <AdSlot728x90
                        divId="div-gpt-ad-1707804176041-3"
                        minWidth="728px"
                        minHeight="90px"
                    />
                </div>
            )}
            {/*cities links panel*/}
            <div className="mx-4 mt-4 md:mx-6 my-2 p-3 border border-zinc-300 rounded-lg">
                <div className="inline-flex flex-wrap gap-x-1 text-[16px] font-semibold mb-2">
                    <h2>{isGold ? "देश के प्रमुख शहरों में आज सोने का भाव" : "देश के प्रमुख शहरों में आज चांदी का भाव"}
                        {" "}  <span className="text-[#6A7282]">{isGold ? `(Gold prices in major cities across the country today)` : `(Silver prices in major cities across the country today)`}</span></h2>
                </div>

                <CityLinksPanel cityList={isGold ? goldCityData : silverCityData} city={city} colors={colorClasses} isGold={isGold} />
            </div>
            {/* seo based components */}

            <div className="mx-4 mt-4 md:mx-6 my-2 p-3 border border-zinc-300 rounded-lg">
                <h2 className='inline-flex flex-wrap gap-x-1 text-[16px] font-semibold mb-2'> {isGold ? "सोना खरीदने से जुड़ी सलाह: किन बातों का रखें विशेष ध्यान ? (Gold buying suggestions)" : `चांदी की खरीदारी कैसे करें? (Silver Buying Guide)`} </h2>
                {/* ul */}
                {isGold ? <ul className='list-disc list-inside text-sm font-semibold  text-gray-600 mt-2'>
                    <li> सोना या उसके गहने खरीदते समय क्या करें और क्या ना करें? </li>

                    <li> 24 कैरेट और 22 कैरेट सोने में को एक मत समझिए. फर्क जानिए ?</li>

                    <li> गहनों के लिए कौन सा सोना मुफीद ? ये भी जान लीजिए</li>

                    <li> सस्ता और बेहतर डील के लिए कब करें सोने की खरीदारी ?</li>

                    <li>जेवर और सोने के बिस्किट को लेकर गफलत में हैं ? जानें कब क्या खरीदें ?</li>
                </ul> : <ul className='list-disc list-inside text-sm font-semibold  text-gray-600 mt-2'>
                    <li> चांदी की खरीदारी में ध्यान रखने वाली जरूरी बातें </li>

                    <li>क्या होती है हॉलमार्क चांदी और क्यों है ये जरूरी?</li>

                    <li>सिल्वर बार लें या ज्वेलरी?</li>
                    <li>चांदी खरीदने का सबसे सही समय कब होता है?</li>
                </ul>}
                <p className='text-md  text-gray-600 mt-2'>
                    {isGold ? `कहते हैं 'सोना है सदा के लिए'. सोने की बढ़ती महंगाई में जल्दबाजी में लिया गया फैसला पछतावे का कारण बन सकता है. इसलिए खरीदारी से पहले कुछ बुनियादी बातों पर ध्यान देना बेहद जरूरी है. सबसे पहले सोने की प्योरिटी पर ध्यान देना चाहिए. 24 कैरेट सोना प्योर होता है. ये इतना नरम होता है कि इससे ज्वैलरी नहीं बनती है. जेवराती सोना 22 कैरेट, 18 कैरेट और अब 14 कैरेट में मिलता है. 22 कैरेट में कम मिलावट, 18 में ज्यादा और 14 में उससे भी ज्यादा अन्य धातुओं की मिलावट होती है. आप कौन सा सोना खरीदने जा रहे हैं और उस दिन उसका भाव क्या है ये जानना भी बेहद जरूरी है क्योंकि सोने का भाव हर रोज बदलता रहता है. सोने पर हॉल मार्क, उसके वजन पर जरूर नजर रखें. मेकिंग चार्ज पर मोल-भाव कर सकते हैं. खरीदारी का पक्का बिल लेना न भूलें.`
                        : `अगर आप  ${city_hn} में चांदी खरीदने की सोच रहे हैं, तो ज्वेलर के पास जाने से पहले आज का लाइव सिल्वर रेट जरूर चेक कर लें. चांदी हमेशा किसी रजिस्टर्ड और भरोसेमंद दुकान से ही खरीदें और उस पर बने हॉलमार्क अंक (जैसे 999 या 925) पर विशेष ध्यान दें. खरीदारी के समय बिल में अंकित शुद्धता, मेकिंग चार्ज, GST और धातु के सटीक वजन की जांच खुद करना एक समझदारी भरा कदम है. याद रखें, निवेश के लिए 999 शुद्ध चांदी के सिक्के या बार और आभूषणों के लिए 925 स्टर्लिंग सिल्वर सबसे उपयुक्त मानी जाती है.`}
                </p>
            </div>
            <div className="mx-4 mt-4 md:mx-6 my-2 p-3 border border-zinc-300 rounded-lg">
                <h2 className='inline-flex flex-wrap gap-x-1 text-[16px] font-semibold mt-4 mb-2'> {isGold ? `${city_hn} में खरीदने जा रहे सोना तो 5 बातें भूलें नहीं (Gold Buying: A Complete Guide)` : ` ${city_hn} में शुद्ध हॉलमार्क चांदी की पहचान कैसे करें?`} </h2>
              { !isGold && <ul className='list-disc list-inside text-sm font-semibold  text-gray-600 mt-2'>
                    <li>क्या होती है हॉलमार्क चांदी?</li>

                    <li>चांदी पर लगा हॉलमार्क कैसे चेक करें?</li>

                    <li>असली और नकली चांदी की पहचान करने के आसान तरीके</li>
                </ul>}
                <p className='text-md  text-gray-600 mt-2'>
                    {isGold ? `यदि आप  ${city_hn} के किसी शहर में प्योर सोना (24 कैरेट) या जेवराती सोना खरीदने जा रहे हैं तो सबसे पहले उस दिन का सोने का भाव जरूर देख लें. सोने की शुद्धता का प्रमाण BIS हॉलमार्क होता है. इसको कतई न भूलें. खरीदारी करते समय 6 चीजें जरूर याद रखें;  पहला- सोने का उस दिन का भाव, दूसरा-सही वजन, तीसरा- HUID कोड, चौथा- मेकिंग चार्ज, पांचवां- GST, छठवां-पक्का बिल. जेवरात के लिए 22 और 18 कैरेट ठीक माना जाता है. निवेश के लिए 24 कैरेट प्योर सोना या डिजिटल गोल्ड पर फोकस करें.  `
                        : ` खरीदारी करते समय चांदी की शुद्धता की पुष्टि करना बेहद आवश्यक है.  ${city_hn} में जब भी चांदी लें, उस पर 999 या 925 का शुद्धता कोड, BIS हॉलमार्क और ज्वेलर का लोगो जरूर चेक करें. असली और नकली के झंझट से बचने के लिए हमेशा प्रमाणित ज्वेलर से विस्तृत टैक्स बिल के साथ ही खरीदारी करें.`}
                </p>
            </div>
            {isGold && <div className="mx-4 mt-4 md:mx-6 my-2 p-3 border border-zinc-300 rounded-lg">
                <h2 className='inline-flex flex-wrap gap-x-1 text-[16px] font-semibold mb-2'> {isGold ? `सोने पर कैसे पहचाने BIS हॉलमार्क ?` : " "} </h2>


                <div>
                    <ul className='list-disc list-inside text-sm font-semibold  text-gray-600 mt-2'>
                        <li>BIS हॉलमार्क होता क्या है ?
                        </li>
                        <li>असली और नकली सोने की पहचान कैसे करें ? </li>
                         
                    </ul>
                    <p className='text-md  text-gray-600 mt-2'>{`सोना असली है या नकली, इसे पहचानना आम आदमी के बस की बात नहीं. इसलिए आम लोगों के लिए BIS हॉलमार्क की सुविधा दी गई है. यानी BIS हॉलमार्क ही ग्राहक को सोने की शुद्धता की गारंटी देता है. BIS हॉलमार्क जांचने के लिए सबसे देखें- आपको BIS के Logo के साथ सोने की शुद्धता दिखेगी. जैसे- 24K/999, 22K/916, 18K/750. इसके साथ ही 6 अंकों का यूनिक कोड भी दिखाई देगा. अब इस हॉलमार्क को जांचने के लिए 'BIS Care' मोबाइल एप पर HUID नंबर की जांच कर सकते हैं. सोने की फेयर डील के लिए ${city_hn} में सर्टिफाइड ज्वैलर्स से ही BIS हॉलमार्क वाला सोना खरीदें और बिल वही लें जिसपर HUID नंबर दर्ज हो.`}</p>
                </div>




            </div>}
            <div className="mx-4 mt-4 md:mx-6 my-2 p-3 border border-zinc-300 rounded-lg">
                <h2 className='inline-flex flex-wrap gap-x-1 text-[16px] font-semibold mb-2'> {isGold ? `सोने की खरीदी पर GST और मेकिंग चार्ज की गणित क्या है ?` : `${city_hn} में चांदी खरीदने पर कितना GST और मेकिंग चार्ज लगता है?`} </h2>

                {isGold ?
                    <div>
                        <ul className='list-disc list-inside text-sm font-semibold  text-gray-600 mt-2'>
                            <li>सोने पर GST का कैलकुलेशन


                            </li>
                            <li>मेकिंग चार्ज पर भी लगता है GST ?</li>
                            <li>कैसे बनता है खरीदारी का पक्का बिल ?</li>
                        </ul>
                        <p className='text-md  text-gray-600 mt-2'>{`${city_hn} में सोने की खरीदारी कर रहे हैं तो 3 फीसदी GST देना होगा. ज्वैलरी खरीद रहे हैं तो दुकानदार आपसे मेकिंग चार्ज (गहना बनाने का चार्ज) लेगा. वैसे तो ज्वैलर सोने के रेट के साथ मेकिंग चार्ज जोड़कर 3 फीसदी GST लेता है पर गहने रिपेयर करने या मोडिफाई कराने पर ज्वैलर लेबर चार्ज के साथ 5 फीसदी का GST लेता है. किसी तरह की गफलत से बचने के लिए ज्वैलर से पक्का और डिटेल्ड बिल जरूर लें, जिसपर हर अमाउंट का अलग-अलग ब्रेकअप हो.`}</p>
                    </div>

                    : <div>
                        <ul className='list-disc list-inside text-sm font-semibold  text-gray-600 mt-2'>
                            <li>चांदी पर कितना GST लगता है?</li>
                            <li>ज्वेलरी का मेकिंग चार्ज </li>
                            <li>कैसे बनता है फाइनल बिल?</li>
                        </ul>
                        <p className='text-md  text-gray-600 mt-2'>{`${city_hn} में चांदी खरीदने पर मूल चांदी की कीमत पर 3% GST लागू होता है. इसके साथ ही, चांदी के गहनों या बर्तनों के मेकिंग चार्ज (बनावट शुल्क) पर अलग से 5% GST जोड़ा जाता है. आपका जो फाइनल बिल बनता है, उसमें चांदी का उस दिन का भाव, मेकिंग चार्ज और दोनों टैक्स का अलग-अलग व स्पष्ट विवरण होना चाहिए. इसलिए भुगतान करने से पहले बिल की जांच ध्यान से जरूर करें.`}</p>
                    </div>}

            </div>
            <div className="mx-4 mt-4 md:mx-6 my-2 p-3 border border-zinc-300 rounded-lg">
                <h2 className='inline-flex flex-wrap gap-x-1 text-[16px] font-semibold mb-2'> {isGold ? `${city_hn} में गोल्ड इन्वेस्टमेंट के Tips (Gold Investment Guide)` : `${city_hn} में चांदी में निवेश के कौन-कौन से तरीके हैं? (Silver Investment Tips)`} </h2>

                {isGold ?
                    <div>

                        <p className='text-md  text-gray-600 mt-2'>{`${city_hn} में सोने में निवेश करने का मन बना रहे हैं तो कई ऑप्शन अवेलेबल हैं. आप अपनी वित्तीय जरूरतों के मद्देनजर निवेश का तरीका चुन सकते हैं.
                         `}</p>

                        <ul className='list-disc list-inside text-sm font-semibold  text-gray-600 mt-2'>
                            <li>फिजिकल गोल्ड (भौतिक सोना): यानी सोने के सिक्के, बिस्किट या गहने खरीदकर भविष्य के लिए रख सकते हैं. ये पारंपरिक तरीका है.</li>
                            <li>
                                गोल्ड ETF (Digital Silver/Gold): फिजिकल गोल्ड को लेकर सुरक्षा की चिंता रहती है. ऐसे में शेयर बाजार में डिजिटल गोल्ड में निवेश कर सकते हैं.</li>
                            {/* <li>सॉवरेन गोल्ड बॉन्ड (SGB): सरकार द्वारा जारी बॉन्ड, जिसमें सोने के बढ़ते दाम के साथ सालाना निश्चित ब्याज भी मिलता है.</li> */}
                            <li>गोल्ड म्यूचुअल फंड: SIP या एकमुश्त (Lump sum) तरीके से सोने में निवेश कर सकते हैं.
                            </li>

                        </ul>
                        <p className='text-md  text-gray-600 mt-2'>{`सोने में निवेश से पहले उसके भाव की हिस्ट्री पर नजर जरूर डाल लें. एक्सपर्ट की राय के साथ सही वक्त पर सही जगह निवेश करने पर रिटर्न भी अच्छा रहता है. इसमें आपके जोखिम लेने की क्षमता और वित्तीय लक्ष्य को ध्यान में रखना होगा.`}</p>
                    </div>

                    : <div>

                        <p className='text-md  text-gray-600 mt-2'>{`${city_hn} में चांदी में निवेश करने के कई सुरक्षित विकल्प उपलब्ध हैं. आप अपने बजट और निवेश के लक्ष्यों के अनुसार सही माध्यम चुन सकते हैं:
                        
                           `}</p>
                        <ul className='list-disc list-inside text-sm font-semibold  text-gray-600 mt-2'>
                            <li>फिजिकल सिल्वर (भौतिक चांदी): चांदी के सिक्के, बार या बिस्किट खरीदकर पारंपरिक तरीके से निवेश करें.</li>
                            <li> सिल्वर ETF (Digital Silver): शेयर बाजार के माध्यम से बिना किसी सुरक्षा या रखरखाव की चिंता के डिजिटल चांदी में पैसा लगाएं.</li>
                            <li> सिल्वर म्यूचुअल फंड: अगर आप डायरेक्ट ETF में ट्रेड नहीं करना चाहते, तो म्यूचुअल फंड (SIP/Lump sum) के जरिए आसानी से निवेश कर सकते हैं.</li>
                            <li>सिल्वर फ्यूचर्स (MCX): यदि आपको कमोडिटी मार्केट का अच्छा अनुभव है, तो MCX एक्सचेंज के जरिए ट्रेडिंग का विकल्प चुन सकते हैं.</li>

                        </ul>
                        <p className='text-md  text-gray-600 mt-2'>{` निवेश टिप: निवेश का फैसला लेने से पहले ${city_hn} में आज का लाइव सिल्वर रेट, अपना वित्तीय लक्ष्य और जोखिम उठाने की क्षमता (Risk Appetite) ज़रूर जांच लें.`} </p>
                    </div>}

            </div>
            <div className="mx-4 mt-4 md:mx-6 my-2 p-3 border border-zinc-300 rounded-lg">
                <h2 className='inline-flex flex-wrap gap-x-1 text-[16px] font-semibold mb-2'> {isGold ? `${city_hn} के सोने का भाव कभी ज्यादा कभी कम क्यों ?` : `${city_hn} में चांदी के भाव क्यों घटते-बढ़ते हैं?`} </h2>

                {isGold ?
                    <div>

                        <p className='text-md  text-gray-600 mt-2'>{`सोने के भाव पर अंतरराष्ट्रीय, राष्ट्रीय और स्थानीय कारकों का प्रभाव रहता है. इसलिए इसका भाव स्थिर रहने की बजाय बदलता रहता है.
                          `}</p>
                        <ul className='list-disc list-inside text-sm font-semibold  text-gray-600 mt-2'>
                            <li>अंतरराष्ट्रीय कारण: सोने की वैश्विक मांग और आपूर्ति (Demand and Supply) के आधार पर अंतरराष्ट्रीय बाजार में सोने का बेस प्राइस तय होता है.</li>
                            <li>केंद्रीय बैंकों की खरीदारी: दुनिया भर के केंद्रीय बैंक मुद्रा भंडार को सुरक्षित रखने के लिए सोना खरीदते हैं. इससे सप्लाई कम होती है कीमतें चढ़ जाती हैं.</li>
                            <li>डॉलर Vs रुपया: डॉलर का रुपए के मुकाबले कमजोर और मजबूत होना सोने के भाव पर असर डालता है.</li>
                            <li>ब्याज दरें: दुनिया भर के केंद्रीय बैंकों खासकर अमेरिका के फेड रिजर्व की ब्याज नीतियां भी सोने के भाव पर असर डालती हैं.</li>
                            <li>त्यौहारी और शादीयों के सीजन की मांग: त्यौहारी माहौल और शादियों के सीजन में बढ़ी मांग भी भाव को बढ़ाती है.</li>

                        </ul>
                        <p className='text-md  text-gray-600 mt-2'>{`वैश्विक हालात और नीतियां जिम्मेदार: अंतरराष्ट्रीय तनाव, आर्थिक नीतियां भी भाव के उतार-चढ़ाव के लिए जिम्मेदार हैं. `}</p>
                    </div>

                    : <div>

                        <p className='text-md  text-gray-600 mt-2'>{`${city_hn} में चांदी की दरें केवल स्थानीय मांग से तय नहीं होतीं, बल्कि इन पर कई राष्ट्रीय और अंतरराष्ट्रीय कारकों का असर पड़ता है: `}</p>
                        <ul className='list-disc list-inside text-sm font-semibold  text-gray-600 mt-2'>
                            <li>अंतरराष्ट्रीय बाजार: वैश्विक बाजार (Global Market) में चांदी के दामों का रुख.</li>
                            <li>रुपया बनाम डॉलर: अमेरिकी डॉलर के मुकाबले भारतीय रुपये की चाल.</li>
                            <li>औद्योगिक मांग (Industrial Demand): सोलर पैनल, इलेक्ट्रॉनिक्स और ऑटोमोबाइल इंडस्ट्री में चांदी की खपत.</li>
                            <li>महंगाई और ब्याज दरें: इन्फ्लेशन रेट और केंद्रीय बैंकों की मौद्रिक नीतियां.</li>
                            <li> त्योहारी व स्थानीय मांग: देश और शहर में शादी-ब्याह और त्योहारों के दौरान खरीदारी.</li>
                            <li>ग्लोबल सेंटीमेंट्स: दुनिया भर के आर्थिक हालात और निवेशकों का रुझान.</li>
                        </ul>
                        <p className='text-md  text-gray-600 mt-2'>{`इन सभी वजहों के मिले-जुले असर के कारण ही  ${city_hn} में रोजाना चांदी के भाव में बदलाव आता है.`}</p>
                    </div>}

            </div>

            {categoryListData?.content?.length > 0 &&
                <section className="mx-4 mt-2 md:mx-6 mb-4 ">
                    <NewsGrid
                        newsData={categoryListData}
                        isGold={isGold}
                    />
                </section>}

            {/* btf ads */}
            {isScroll && (
                <div className="mx-4 md:mx-6 ">

                    <AdSlot300x250
                        divId="div-gpt-ad-1659435474737-0"
                        minWidth="300px"
                        minHeight="250px"
                    />
                    <div className="my-10">

                        <AdSlot728x90
                            divId="div-gpt-ad-1659425743360-0"
                            minWidth="728px"
                            minHeight="90px"
                        />
                    </div>
                </div>
            )}
            {/* faq component */}
            <div className="mx-4 mt-4 md:mx-6">
                <FaqAccordion
                    isGold={isGold}
                    title={
                        isGold
                            ? `${cityLabel} गोल्ड रेट से जुड़े सवाल-जवाब (${city ? city.charAt(0).toUpperCase() + city.slice(1) : ""} Gold Price FAQs)`
                            : `${cityLabel} सिल्वर रेट से जुड़े सवाल-जवाब (${city ? city.charAt(0).toUpperCase() + city.slice(1) : ""} Silver Price FAQs)`
                    }
                    items={faqItems}
                />
            </div>
        </section>
    )
}

export default GoldSilverRatesPage